import React from 'react';
import { FormControl, FormLabel, FormGroup, FormControlLabel, Checkbox, Box } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateSchedule } from '../../../../state';

const DAYS_OF_WEEK = [
  { label: 'Sunday', value: 0 },
  { label: 'Monday', value: 1 },
  { label: 'Tuesday', value: 2 },
  { label: 'Wednesday', value: 3 },
  { label: 'Thursday', value: 4 },
  { label: 'Friday', value: 5 },
  { label: 'Saturday', value: 6 },
];

const WeekDaysEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentRecurringTask } = useAppSelector(state => state.recurringTask);

  const handleChange = (day: number) => {
    const currentDays = currentRecurringTask?.schedule?.weekDays || [];
    const newDays = currentDays.includes(day)
      ? currentDays.filter(d => d !== day)
      : [...currentDays, day].sort((a, b) => a - b);
    
    dispatch(updateSchedule({ weekDays: newDays }));
  };

  const selectedDays = currentRecurringTask?.schedule?.weekDays || [];

  return (
    <FormControl component="fieldset" size="small">
      <FormLabel component="legend" sx={{ fontSize: '0.875rem', mb: 1 }}>Days of Week</FormLabel>
      <FormGroup>
        <Box display="flex" flexWrap="wrap" gap={1}>
          {DAYS_OF_WEEK.map((day) => (
            <FormControlLabel
              key={day.value}
              control={
                <Checkbox
                  checked={selectedDays.includes(day.value)}
                  onChange={() => handleChange(day.value)}
                  size="small"
                />
              }
              label={day.label}
              sx={{ 
                minWidth: '120px',
                '& .MuiFormControlLabel-label': { fontSize: '0.875rem' }
              }}
            />
          ))}
        </Box>
      </FormGroup>
    </FormControl>
  );
};

export default WeekDaysEdit;
